import { render, staticRenderFns } from "./DetailReportSales.vue?vue&type=template&id=ca01b8dc&scoped=true&"
import script from "./DetailReportSales.vue?vue&type=script&lang=js&"
export * from "./DetailReportSales.vue?vue&type=script&lang=js&"
import style0 from "./DetailReportSales.vue?vue&type=style&index=0&id=ca01b8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca01b8dc",
  null
  
)

export default component.exports